module.exports = __webpack_public_path__ + "img/icon-custom.3a18d677.png";